var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "download--menu-item", class: [_vm.menuItemClass] },
    [
      _vm.depth > 0
        ? _c(
            "a",
            {
              staticClass: "download--menu-item-link",
              class: {
                active:
                  _vm.depth == _vm.$root.getParents().length &&
                  _vm.$root.getParents().includes(_vm.item.id),
              },
              style: _vm.indent,
              on: {
                click: function ($event) {
                  _vm.toggleChildren($event)
                  _vm.clickHandler(_vm.item.id)
                },
              },
            },
            [
              _c("i", { class: _vm.iconClass }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.item.label))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.children, function (child) {
        return [
          _c("download-menu", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showChildren,
                expression: "showChildren",
              },
            ],
            key: child.id,
            attrs: {
              item: child,
              children: child.children,
              depth: _vm.depth + 1,
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }